import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import "./Home.css";
import Slider from "../../components/Slider/Slider";
//import HomeBanner from "./../../assets/homepagebannernew2.webp";
//import HomeBannerMobil from "./../../assets/homepagebannermobile.webp";
import HomeBannerMen from "./../../assets/home1.webp";
//import HomeBannerWomen from "./../../assets/home2.webp";
import HomeBannerMobil from "./../../assets/home1mobile.webp";
import Logo1 from "./../../assets/home/test1.png";
import Logo2 from "./../../assets/home/test2.png";
import HomeProduct from "../../components/HomeProduct/HomeProduct";
import Application from "../../components/Application/Application";
import categoryData from "../../api/categories";
import { formatPage } from "../../utils/formatPage";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import CatalogSection from "../../components/CatalogSection/CatalogSection";
// import { useLocation } from "react-router-dom";
// const WelcomeOverlay = React.lazy(
//   () => import("../../views/WelcomeModal/WelcomeModal"),
// );
const Home = () => {
  const { t } = useTranslation();

  // const location = useLocation();

  // const [open, setOpen] = useState(false);
  // const [showWelcome, setShowWelcome] = useState(false);

  // useEffect(() => {
  //   // sadece ana sayfada
  //   if (location.pathname !== "/") return;

  //   const dismissed = localStorage.getItem("welcome_modal_dismissed");
  //   if (dismissed === "1") return;

  //   // 5 sn sonra göster
  //   const timer = setTimeout(() => {
  //     setShowWelcome(true); // lazy component render edilmeye başlanır
  //     setOpen(true); // modal açık gelsin
  //   }, 2000);

  //   return () => clearTimeout(timer);
  // }, [location.pathname]);

  // const handleClose = () => {
  //   localStorage.setItem("welcome_modal_dismissed", "1");
  //   setOpen(false);
  // };

  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("home.meta.title"),
      description: t("home.meta.description"),
      keywords: t("home.meta.keywords"),
      siteName: "Touch Of Soul",
      favicon: "/faviconnew.png",
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com",
      ogType: "website", // ya da 'website'
    });
  }, [setSeo, t]);

  return (
    <>
      <Slider />
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h3 className="text-center fw-normal py-5 pb-3">
              {t("Shop by Category")}
            </h3>
          </div>
        </div>
        <div className="row">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 3,
              },
              1440: {
                slidesPerView: 4,
              },
            }}
          >
            {categoryData.category.map((category) => (
              <SwiperSlide key={category.id}>
                <a
                  href={`/category/${formatPage(category.categoryname)}`}
                  className="text-decoration-none"
                >
                  <img
                    className="w-100 d-block"
                    loading="lazy"
                    decoding="async"
                    alt={t(`${category.categoryname}`)}
                    src={category.categoryimage}
                    width={300}
                    height={375}
                    style={{ height: "auto" }}
                  />

                  <p className="text-center fw-light mt-3 mb-5 text-dark fs-6 text-uppercase">
                    {t(category.translationKey) || category.categoryname}
                  </p>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div className="container-fluid mt-5">
        <div className="row text-center">
          {/* DESKTOP */}
          <div className="col-12 px-0 d-none d-sm-block">
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {/* Slide 1 */}
              {/* <SwiperSlide>
                <div className="bannerSlide position-relative">
                  <a href="/perfume">
                    <img
                      src={HomeBannerMen}
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={1920}
                      style={{ height: "auto", display: "block" }}
                    />
                  </a>
                  Overlay (ortada)
                  <div className="position-absolute top-50 start-50 translate-middle">
                    <a href="/perfume" className="text-decoration-none">
                      <p className="text-white fw-lighter fs-3 m-0">
                        {t("Discover more")}
                      </p>
                    </a>
                  </div>
                </div>
              </SwiperSlide> */}

              {/* Mobile Slide 1 */}
              <SwiperSlide>
                <div className="bannerSlide position-relative overflow-hidden">
                  <a href="/perfume">
                    <img
                      src={HomeBannerMen}
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={450}
                      style={{
                        height: "100%",
                        display: "block",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                  <div className="position-absolute top-50 start-50 translate-middle">
                    <a href="/perfume" className="text-decoration-none">
                      <p className="text-white fw-lighter fs-3 m-0">
                        {t("Discover more")}
                      </p>
                    </a>
                  </div>
                  {/* Resmin üzerinde alt-orta yazı + iki logo */}
                  <div className="bannerLogoContent position-absolute start-50 translate-middle-x text-center">
                    <p className="text-white fw-light mb-3 bannerLogoText">
                      {t("Memberof")}
                    </p>

                    <div className="d-flex align-items-center justify-content-center gap-3">
                      <img src={Logo1} alt="Logo 1" className="bannerLogo" />
                      <img src={Logo2} alt="Logo 2" className="bannerLogo" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Slide 2 
              <SwiperSlide>
                <div className="bannerSlide position-relative">
                  <a href="/perfume">
                    <img
                      src={HomeBannerWomen}
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={1920}
                      style={{ height: "auto", display: "block" }}
                    />
                  </a>

                  <div className="position-absolute top-50 start-50 translate-middle">
                    <a href="/perfume" className="text-decoration-none">
                      <p className="text-white fw-lighter fs-3 m-0">
                        {t("Discover more")}
                      </p>
                    </a>
                  </div>
                </div>
              </SwiperSlide>*/}
            </Swiper>
          </div>

          {/* MOBILE */}
          <div className="col-12 px-0 d-block d-sm-none">
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {/* Mobile Slide 1 */}
              <SwiperSlide>
                <div className="bannerSlide position-relative">
                  <a href="/perfume">
                    <img
                      src={HomeBannerMobil} // 1. mobil görsel
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={450}
                      style={{ height: "100%", display: "block" }}
                    />
                  </a>

                  {/* Overlay (altta) */}
                  <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                    <a href="/perfume" className="text-decoration-none">
                      <p className="text-white fw-light text-decoration-underline m-0">
                        {t("Discover more")}
                      </p>
                    </a>
                  </div>
                </div>
              </SwiperSlide>

              {/* Mobile Slide 2
              <SwiperSlide>
                <div className="bannerSlide position-relative">
                  <a href="/perfume">
                    <img
                      src={HomeBannerMobil} // 2. mobil görsel (ekleyeceksin)
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={450}
                      style={{ height: "100%", display: "block" }}
                    />
                  </a>

                  <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                    <a href="/perfume" className="text-decoration-none">
                      <p className="text-white fw-light text-decoration-underline m-0">
                        {t("Discover more")}
                      </p>
                    </a>
                  </div>
                </div>
              </SwiperSlide> */}
            </Swiper>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MÜKEMEL
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("Visit our Store")}
          </h3>
          <HomeProduct />
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MÜKEMEL
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("CustomerReviews")}
          </h3>
          <div className="col-lg-8">
            <CustomerReviews />
          </div>
        </div>
      </div>
      <CatalogSection />
      <Application />
      <div className="container"></div>
      {/* {location.pathname === "/" && showWelcome && (
        <React.Suspense fallback={null}>
          <WelcomeOverlay open={open} onClose={handleClose} />
        </React.Suspense>
      )} */}
    </>
  );
};
export default Home;
